module.exports = __webpack_public_path__ + "static/media/toolbox-dimple-blue.e8ae5836.svg";